export default [
  {
    label: "0 miles",
    value: "0",
  },
  {
    label: "1/8 miles",
    value: "1/8",
  },
  {
    label: "1/4 miles",
    value: "1/4",
  },
  {
    label: "1/2 miles",
    value: "1/2",
  },
  {
    label: "1 miles",
    value: "1",
  },
  {
    label: "2 miles",
    value: "2",
  },
  {
    label: "5 miles",
    value: "5",
  },
  {
    label: "10 miles",
    value: "10",
  },
  {
    label: "20 miles",
    value: "20",
  },
  {
    label: "30 miles",
    value: "30",
  },
  {
    label: "40 miles",
    value: "40",
  },
  {
    label: "50 miles",
    value: "50",
  },
];
